import {Routes, Route} from "react-router-dom";
import ApplicationFirstStepScreen from "../atomic/pages/application/application-first-step.screen";
import ReferrerLanding from "../atomic/pages/application/referral-landing.screen";
import ApplicationSecondStepScreen from "../atomic/pages/application/application-second-step.screen";
import ApplicationThirdStepScreen from "../atomic/pages/application/application-third-step.screen";
import NumberVerificationScreen from "../atomic/pages/application/application-fourth-step.screen";
import {ApplicationInitialStepScreen} from "../atomic/pages/application/application-initial-step.screen.jsx";
import {RepeatedAccountScreen} from "../atomic/pages/application/repeated-account.screen";
import {EvaluationScreen} from "../atomic/pages/application/evaluation.screen";
import GenericForm from "../atomic/pages/generic-form/generic-form.screen.jsx";

const ApplicationRouter = () => {
    return (
        <Routes>
            <Route path="landing" element={<ReferrerLanding/>}/>
            <Route path='application/initial-step' element={<ApplicationInitialStepScreen/>}/>
            <Route path="application/first-step" element={<ApplicationFirstStepScreen/>}/>
            <Route path="application/second-step" element={<ApplicationSecondStepScreen/>}/>
            <Route path="application/third-step" element={<ApplicationThirdStepScreen/>}/>
            <Route path="application/fourth-step" element={<NumberVerificationScreen/>}/>
            <Route path="application/repeated-account/:curp" element={<RepeatedAccountScreen/>}/>
            <Route path="application/evaluation" element={<EvaluationScreen/>}/>
            <Route path="credit-line-form/form/:web_uri" element={<GenericForm type_of_form="credit_line"/>}/>
        </Routes>
    );
};

export default ApplicationRouter; 